const vendorMessagePath = 'vendor.';
const buttonMessagePath = 'button.';

const translations = {
    COMPATIBILITY_LABEL : vendorMessagePath + 'compatibility',
    CONTACT_US_LABEL : 'contact us',
    KEY_FEATURES_LABEL : vendorMessagePath + 'keyFeatures',
    CLINCIAN_REVIEW : vendorMessagePath + 'clinicianReview',
    RESEARCH_REVIEWS : vendorMessagePath + 'researchReviews', 
    CLINICAL_RESEARCHER_REVIEW : vendorMessagePath + 'clinicalResearcherReview', 

    OPEN_TOOL_BUTTON_LABEL : buttonMessagePath + 'openTool',
    WATCH_DEMO_BUTTON_LABEL : buttonMessagePath + 'watchDemo'
}

export default translations